import React from "react";

export default function RadioComponent({
  status = false,
  state = "default", // "default" | "disabled"
  color = "neutral", // "neutral" | "brand"
  onChange = () => {}
}) {
  const isDisabled = state === "disabled";
  const isChecked = status;

  const colorStyles = {
    neutral: {
      border: isChecked ? "#000" : "#4C4C4C",
      fill: isChecked ? "#000" : "transparent"
    },
    brand: {
      border: isChecked ? "#8A2BE2" : "#B078FF",
      fill: isChecked ? "#8A2BE2" : "transparent"
    }
  };

  const disabledStyles = {
    border: "#A5A5A5",
    fill: isChecked ? "#A5A5A5" : "transparent"
  };

  const styles = isDisabled ? disabledStyles : colorStyles[color];

  return (
    <div
      onClick={() => !isDisabled && onChange()}
      style={{
        width: 13,
        height: 13,
        borderRadius: "50%",
        border: `1px solid ${styles.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: isDisabled ? "not-allowed" : "pointer",
        opacity: isDisabled ? 0.6 : 1,
        transition: "0.2s"
      }}
    >
      {isChecked && (
        <div
          style={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            background: styles.fill
          }}
        />
      )}
    </div>
  );
}
